<template>
  <div v-if="questions && questions.length" class="similar-questions">
    <h2 class="similar-questions-title">
      {{ type }} questions
    </h2>
    <div
      v-for="(q, i) in questions"
      :key="i"
      class="question"
    >
      <div class="info">
        <UserLink type="similar" data-event="popular_question_user.click" :info="q" />
        <div class="badge">
          <UserBadge v-if="q.userRole === 0 || q.userRole === 2 || (q.userPerms && q.userPerms.includes('lms.qa-support'))" :badge="'Instructor'" />
          <UserBadge v-if="!(q.userRole === 0 || q.userRole === 2 || (q.userPerms && q.userPerms.includes('lms.qa-support'))) && q.userPaid && +q.userLevel >= 8" :badge="'Super learner'" tooltip="This user is a Super Learner. To become a Super Learner, you need to reach Level 8." />
        </div>
        <div class="stats">
          <div class="votes">
            {{ q.votes || 0 }} <UpArrowIcon />
          </div>
          <div class="answers">
            {{ q.answers }} <CommentIcon />
          </div>
        </div>
      </div>
      <nuxt-link
        :title="q.title"
        class="title"
        :to="`/question/${q.url}/`"
        data-event="popular_question.click"
      >
        <span v-if="q.resolved" class="resolved">Resolved:</span>
        {{ q.title }}
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import UpArrowIcon from '../assets/svg/icon-up-arrow.svg?vue-component';
import CommentIcon from '../assets/svg/icon-comment.svg?vue-component';
import UserLink from './UserLink';
import UserBadge from '../UserBadge';

export default {
  components: {
    UpArrowIcon,
    CommentIcon,
    UserLink,
    UserBadge,
  },
  layout: 'user',
  props: {
    type: { type: String, required: true },
    question: { type: Number, default: 0, required: false },
    relatedQuestions: { type: Array, required: false, default: () => [] },
    popularQuestions: { type: Array, required: false, default: () => [] },
  },
  data() {
    return { questions: this.relatedQuestions.length ? this.relatedQuestions : this.popularQuestions };
  },
};
</script>
<style lang="scss">
.similar-questions {
  background: var(--main-light-shade-2);
  border-radius: 8px;
  padding: var(--spacing-16);
  padding-bottom: var(--spacing-24);

  .similar-questions-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    color: var(--main-dark-light-4);
    margin: 0;
    padding: 0 var(--spacing-xs);

    &:first-letter {
      text-transform: capitalize;
    }
  }

  .question {
    padding: var(--spacing-14);
    box-sizing: border-box;
    border-radius: 3px;
    background: var(--main-light);
    position: relative;
    margin: var(--spacing-8) 0;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    a {
      text-decoration: none;
    }

    .title {
      cursor: pointer;
      width: unset;
      white-space: unset;
      display: block;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: bold;
      color: var(--main-dark-shade-0);
      line-height: 130%;
      font-size: 14px;

      span.resolved {
        color: var(--main-green-shade-1);
      }
    }

    svg {
      vertical-align: middle;

      path[fill] {
        fill: var(--main-light-shade-3);
      }
    }

    .info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--gray);
      margin-bottom: 14px;

      .stats {
        display: flex;
        color: var(--main-dark-light-4);
        font-weight: bold;
        flex: 0 0 auto;

        .votes {
          margin-right: var(--spacing-sm);

          svg {
            vertical-align: text-top;
          }
        }
      }
    }
  }
}

.fa {
  .similar-questions {
    background-color: var(--main-light-shade-2-200);
  }
}
</style>
